export const SUPPLIERS_TYPES_IDS = {
  WYZ_DISTRIBUTOR: 1,
  MANUFACTURER: 2,
  PLATFORM_DISTRIBUTOR: 3,
  SPECIALIST: 4,
  CENTRAL_STOCK: 5,
  WHOLESALER: 6,
  COMPLETE_WHEEL: 8,
  BEST_SOURCING: 1000,
} as const;
